import { Box } from '@mui/material';
import React from 'react';
import { GlobalContentFooter } from '../GlobalContentFooter';
import { globalHeaderHeightNormal, globalHeaderHeightSmall } from '../GlobalHeader/constants';
import { globalInfoHeight } from '../GlobalInfo/constants';
import { globalMenuWidthFull, globalMenuWidthSmall } from '../GlobalMenu/constants';
import { globalPinnedBarWidth } from '../GlobalPinnedBar/constants';
import { globalTabsHeight } from '../GlobalTabsBar/constants';
import { themeColors } from '../JuvareTheme';
import { useHoverSupported, useSmallDevice, useSmallOrMediumDevice } from '../hooks';
export const GlobalContent = (props) => {
    const smallDevice = useSmallDevice();
    const smallOrMediumDevice = useSmallOrMediumDevice();
    const hoverSupported = useHoverSupported() && !smallDevice;
    const headerHeight = !props.hideHeader ? (smallDevice ? globalHeaderHeightSmall : globalHeaderHeightNormal) : 0;
    return (React.createElement(Box, { id: props.tabPath ? undefined : 'main-content-wrapper', className: props.tabPath ? 'main-content-tab' : undefined, "data-tab-path": props.tabPath, sx: [
            {
                display: props.tabPath ? 'none' : 'block',
                boxSizing: 'border-box',
                height: '100%',
                paddingTop: headerHeight + (props.infoOpen ? globalInfoHeight : 0) + (props.showTabs ? globalTabsHeight : 0) + 'px',
                paddingLeft: props.hideMenu
                    ? 0
                    : (props.menuOpen && hoverSupported && props.menuMode !== 'icon-and-label' ? globalMenuWidthSmall : 0) +
                        (props.menuOpen && hoverSupported && props.menuMode === 'icon-and-label' ? globalMenuWidthFull : 0) +
                        (props.pinnedBarOpen && !smallOrMediumDevice ? globalPinnedBarWidth : 0) +
                        'px',
                overflow: 'hidden',
                transition: (theme) => theme.transitions.create('padding-left') + ',' + theme.transitions.create('margin-right', { duration: 400 }),
                '@media print': {
                    padding: 0,
                },
            },
            ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ], "aria-hidden": props.drawerOpen },
        React.createElement(Box, { id: 'main-content', tabIndex: -1, component: 'main', sx: {
                position: 'relative',
                height: '100%',
                overflow: props.fullHeightWithoutScrollbars ? 'hidden' : 'auto',
                backgroundColor: themeColors.background,
                outline: 'none',
                '@media print': {
                    backgroundColor: 'white',
                },
            } }, props.footerCopyright == null && (props.footerLinks == null || props.footerLinks.length === 0) ? (props.children) : (React.createElement(Box, { sx: { minHeight: '100%', display: 'grid', gridTemplateRows: '1fr auto', gridTemplateColumns: '100%' } },
            React.createElement(Box, null, props.children),
            React.createElement(Box, { sx: { alignSelf: 'end' } },
                React.createElement(GlobalContentFooter, Object.assign({}, props))))))));
};
